// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes tooltipFadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.tooltip {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.tooltip-icon {
    width: 100%;
    height: 100%;
}

.tooltip-icon > .tooltip-dropdown-icon {
    top: 40px;
}

.tooltip-dropdown {
    display: none;
    position: absolute;
    top: 105%;
    z-index: 10;
    padding-top: 5px;
}

.tooltip-dropdown__content {
    color: var(--on-surface-variant-transparency);
    background-color: var(--surface-variant-dark-transparency);
    border-radius: var(--radius-extra-small);
    padding: 8px 12px;
    width: fit-content;
    text-align: left;
    min-width: 80px;
}

.tooltip-dropdown__content p {
    margin: 0;
}

.tooltip-dropdown__content .current-report {
    cursor: pointer;
    color: var(--primary);

    &:hover {
        text-decoration: underline;
    }
}

.tooltip-dropdown__content .other-reports:hover {
    cursor: pointer;
    text-decoration: underline;
}

.tooltip--open .tooltip-dropdown {
    animation: tooltipFadeIn 0.15s;
    display: block;
}

/* @media (hover: hover) {
    .tooltip:hover {
        .tooltip-dropdown {
            animation: tooltipFadeIn 0.15s;
            display: block;
        }
    }
} */
`, "",{"version":3,"sources":["webpack://./../../assets/css/tooltips.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,0DAA0D;IAC1D,wCAAwC;IACxC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,qBAAqB;;IAErB;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;;;;;;;GAOG","sourcesContent":["@keyframes tooltipFadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.tooltip {\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n\n.tooltip-icon {\n    width: 100%;\n    height: 100%;\n}\n\n.tooltip-icon > .tooltip-dropdown-icon {\n    top: 40px;\n}\n\n.tooltip-dropdown {\n    display: none;\n    position: absolute;\n    top: 105%;\n    z-index: 10;\n    padding-top: 5px;\n}\n\n.tooltip-dropdown__content {\n    color: var(--on-surface-variant-transparency);\n    background-color: var(--surface-variant-dark-transparency);\n    border-radius: var(--radius-extra-small);\n    padding: 8px 12px;\n    width: fit-content;\n    text-align: left;\n    min-width: 80px;\n}\n\n.tooltip-dropdown__content p {\n    margin: 0;\n}\n\n.tooltip-dropdown__content .current-report {\n    cursor: pointer;\n    color: var(--primary);\n\n    &:hover {\n        text-decoration: underline;\n    }\n}\n\n.tooltip-dropdown__content .other-reports:hover {\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.tooltip--open .tooltip-dropdown {\n    animation: tooltipFadeIn 0.15s;\n    display: block;\n}\n\n/* @media (hover: hover) {\n    .tooltip:hover {\n        .tooltip-dropdown {\n            animation: tooltipFadeIn 0.15s;\n            display: block;\n        }\n    }\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
